<template>
  <div>
    <v-card class="mt-0" width="500">
      <div class="d-flex">
        <v-img src="../../../../assets/logo.png" width="200" class="mx-auto" />
      </div>
      <div class="card-padding pb-0">
        <h4 class="text-h4 font-weight-bolder text-typo mb-2">
          Reset Your Password
        </h4>
      </div>
      <v-card-text>
        <v-form @submit.prevent="confirmReset">
          <v-text-field
            v-model="password"
            label="New Password"
            type="password"
            required
            outlined
            dense
            class="mt-4"
            :rules="[v => !!v || 'Password is required', v => v.length >= 6 || 'Password must be at least 6 characters']"
          ></v-text-field>
          <v-text-field
            v-model="confirmPassword"
            label="Confirm New Password"
            type="password"
            required
            outlined
            dense
            class="mt-4"
            :rules="[v => !!v || 'Password is required', v => v === password || 'Passwords must match']"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="confirmReset"
          :loading="loading"
          :disabled="!isValid"
        >
          Reset Password
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import fb from "../../../../plugins/firebase";
const auth = fb.auth;

export default {
  name: "ResetPasswordConfirm",
  data() {
    return {
      password: "",
      confirmPassword: "",
      loading: false
    };
  },
  computed: {
    isValid() {
      return this.password && 
             this.confirmPassword && 
             this.password === this.confirmPassword && 
             this.password.length >= 6;
    }
  },
  methods: {
    async confirmReset() {
      if (!this.isValid) {
        return;
      }

      this.loading = true;
      try {
        // Get the action code from the URL
        const actionCode = this.$route.query.oobCode;
        if (!actionCode) {
          throw new Error("Invalid or expired reset link");
        }

        // Confirm the password reset
        await auth.confirmPasswordReset(actionCode, this.password);
        
        alert("Password successfully reset! You can now log in with your new password.");
        this.$router.push("/");
      } catch (error) {
        console.error("Error resetting password:", error);
        alert(error.message);
      } finally {
        this.loading = false;
      }
    }
  },
  created() {
    // Check if we have a valid reset code
    if (!this.$route.query.oobCode) {
      //alert("Invalid or expired reset link. Please request a new password reset.");
      this.$router.push("/");
    }
  }
};
</script> 